import { IntervinientesService } from './../../services/intervinientes.service';
import { NgForm } from '@angular/forms';
import { ClientesService } from './../../services/clientes.service';
import { Component, OnInit, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ClientesPymesService } from '../../services/clientes-pymes.service';
import { subscribeOn } from '../../../../node_modules/rxjs/operator/subscribeOn';

@Component({
  selector: 'app-miperfil',
  templateUrl: './miperfil.component.html',
  styles: [`
    .ng-invalid.ng-dirty:not(form){
      border:1px solid red;
    }
    .ng-submitted .ng-invalid:not(form){
      border:1px solid red;
    }
  `]
})
export class MiperfilComponent implements OnInit {
  
  @ViewChild("mensajePerfil") mensajePerfil: ElementRef;
  @ViewChild("mensajeDirecciones") mensajeDirecciones: ElementRef;
  @ViewChild("mensajeRecuperar") mensajeRecuperar: ElementRef;
  @ViewChild("formulario") formulario: ElementRef;
  @ViewChild("formulario2") formulario2: ElementRef;
  @ViewChild ("modalpass") modalpass:ElementRef;
  @ViewChild ("botonCerrar") botonCerrar:ElementRef;

  sectores=[
    "Administración",
    "Agricultura, ganadería y pesca",
    "Arquitectura",
    "Construcción",
    "Diseño Gráfico",
    "Educación",
    "Finanzas",
    "Industria",
    "Informática",
    "Ingeniería",
    "Ocio",
    "Organismos oficiales",
    "Telecomunicaciones",
    "Transporte",
    "Otros"
  ];
  gestoria:boolean;
  direcciones:any[]=[];
  cliente={};
  laboral:boolean;
  fiscal:boolean;
  contable:boolean;
  interviniente={};
  intervinienteRecuperar={};
  activo:boolean=false;
  clientePass={
    CLpassword:"",
    nextPass:"",
    nextPass2:""
  }
  

  constructor(private renderer:Renderer2, private auth:AuthService, private router:Router,
     private clientesService:ClientesService, private clientesPymesService:ClientesPymesService,
     private intervinientesService:IntervinientesService) { 
    if(this.auth.esCliente() || this.auth.esClientePymes()){
      this.cargarCliente();
      if(this.auth.usuarioActivo.CLsector==null){
        this.auth.usuarioActivo.CLsector="-1";
      }
      this.auth.usuarioActivo["CLgestoria"]==1?this.gestoria=true:this.gestoria=false;
      this.cliente={CLcif:""};
      this.getDirecciones();

    }else if(this.auth.esInterviniente()){
      this.intervinientesService.getPerfiles().subscribe();
      this.interviniente["INcif"]="";
      this.cargarInterviniente();
    }else{
      this.router.navigate(["/home"]);
    }
  }

  ngOnInit() {
    
  }

  cargarCliente(){
    if(this.auth.esCliente()){
      this.clientesService.getCliente(this.auth.usuarioActivo["CLcodigo"])
      .subscribe(resp=>{
        this.cliente=resp;
        this.cliente["CLgestoria"]==1?this.gestoria=true:this.gestoria=false;
      });
    }else{
      this.clientesPymesService.getCliente(this.auth.usuarioActivo["CLcodigo"])
      .subscribe(resp=>{
        this.cliente=resp;
        this.cliente["CLservicio_laboral"]==1?this.laboral=true:this.laboral=false;
        this.cliente["CLservicio_fiscal"]==1?this.fiscal=true:this.fiscal=false;
        this.cliente["CLservicio_contable"]==1?this.contable=true:this.contable=false;
      });
    }
  }

  cargarInterviniente(){
    this.intervinientesService.getInterviniente(this.auth.usuarioActivo["INcodigo"])  
    .subscribe(resp=>{
      this.interviniente=resp["interviniente"];
      this.interviniente["INactivo"]==1?this.activo=true:this.activo=false;
    });
  }

  guardarDatos(myform:NgForm){
    if(this.auth.esCliente()){
      this.guardarDatosJuridico(myform);
    }else if(this.auth.esClientePymes()){
      this.guardarDatosPymes(myform);
    }else if(this.auth.esInterviniente()){
      this.guardarDatosInterviniente(myform);
    }
  }

  guardarDatosJuridico(myform:NgForm){

    if(myform.valid){
      this.gestoria==true?this.cliente["CLgestoria"]=1:this.cliente["CLgestoria"]=0;

      this.clientesService.updateCliente(this.cliente, this.cliente["CLcodigo"])
        .subscribe(resp=>{
          this.cargarCliente();
          let texto=this.renderer.createText(resp["mensaje"]);
          if(resp["err"]==false){
            this.renderer.addClass(this.mensajePerfil.nativeElement, "text-success");
          }else{
            this.renderer.addClass(this.mensajePerfil.nativeElement, "text-danger");
          }
          this.renderer.appendChild(this.mensajePerfil.nativeElement,texto);
            setTimeout(() => {
              this.renderer.removeChild(this.mensajePerfil.nativeElement,texto);
            }, 2000);
        });
    }else{
      let texto=this.renderer.createText("Hay errores en el formulario.");
      this.renderer.addClass(this.mensajePerfil.nativeElement, "text-danger");
      this.renderer.appendChild(this.mensajePerfil.nativeElement,texto);
            setTimeout(() => {
              this.renderer.removeChild(this.mensajePerfil.nativeElement,texto);
            }, 2000);
    }
  }

  guardarDatosPymes(myform:NgForm){
    if(myform.valid){
      this.laboral==true?this.cliente["CLservicio_laboral"]=1:this.cliente["CLservicio_laboral"]=0;
      this.fiscal==true?this.cliente["CLservicio_fiscal"]=1:this.cliente["CLservicio_fiscal"]=0;
      this.contable==true?this.cliente["CLservicio_contable"]=1:this.cliente["CLservicio_contable"]=0;

      this.clientesPymesService.updateCliente(this.cliente, this.cliente["CLcodigo"])
        .subscribe(resp=>{
          this.cargarCliente();
          let texto=this.renderer.createText(resp["mensaje"]);
          if(resp["err"]==false){
            this.renderer.addClass(this.mensajePerfil.nativeElement, "text-success");
          }else{
            this.renderer.addClass(this.mensajePerfil.nativeElement, "text-danger");
          }
          this.renderer.appendChild(this.mensajePerfil.nativeElement,texto);
            setTimeout(() => {
              this.renderer.removeChild(this.mensajePerfil.nativeElement,texto);
            }, 2000);
        });
    }else{
      let texto=this.renderer.createText("Hay errores en el formulario.");
      this.renderer.addClass(this.mensajePerfil.nativeElement, "text-danger");
      this.renderer.appendChild(this.mensajePerfil.nativeElement,texto);
            setTimeout(() => {
              this.renderer.removeChild(this.mensajePerfil.nativeElement,texto);
            }, 2000);
    }
  }

  guardarDatosInterviniente(myform:NgForm){
    
      this.activo==true?this.interviniente["INactivo"]=1:this.interviniente["INactivo"]=0;
      this.intervinientesService.updateInterviniente(this.interviniente)
      .subscribe(resp=>{
        let texto=this.renderer.createText(resp["msg"]);
        if(resp["err"]==false){
          this.renderer.addClass(this.mensajePerfil.nativeElement, "text-success");
        }else{
          this.renderer.addClass(this.mensajePerfil.nativeElement, "text-danger");
        }
        this.renderer.appendChild(this.mensajePerfil.nativeElement,texto);
          setTimeout(() => {
            this.renderer.removeChild(this.mensajePerfil.nativeElement,texto);
          }, 2000);
      });
    
  }



  getDirecciones(){
    
    this.clientesService.getDirecciones(this.auth.usuarioActivo.CLcodigo)
      .subscribe(resp=>{
        this.direcciones=resp;
      })
  }

  borrarDireccion(codDireccion){
    this.clientesService.borrarDireccion(codDireccion)
    .subscribe(resp=>{
      if(resp["err"]==false){
              let texto=this.renderer.createText(resp["mensaje"]);
              if(resp["err"]==false){
                this.renderer.addClass(this.mensajeDirecciones.nativeElement, "text-success");
                this.getDirecciones();
              }else{
                this.renderer.addClass(this.mensajeDirecciones.nativeElement, "text-danger");
              }

              this.renderer.appendChild(this.mensajeDirecciones.nativeElement,texto);
              setTimeout(() => {
                this.renderer.removeChild(this.mensajeDirecciones.nativeElement,texto);
              }, 2000);
            }
    });
  }

  guardarNuevaPass(myform:NgForm){
    if(this.auth.esCliente()){
      this.guardarNuevaPassJuridico(myform);
    }else if(this.auth.esClientePymes()){
      this.guardarNuevaPassPymes(myform);
    }else if(this.auth.esInterviniente()){
      this.guardarNuevaPassInterviniente(myform);
    }
  }

  guardarNuevaPassJuridico(myform:NgForm){
    this.renderer.addClass(this.formulario2.nativeElement, "ng-submitted");
    if(myform.valid){
      if(this.clientePass.nextPass==this.clientePass.nextPass2){
        this.clientePass["CLcodigo"]=this.cliente["CLcodigo"];
        this.clientesService.cambiarPass(this.clientePass)
        .subscribe(resp=>{
          let texto=this.renderer.createText("");
          if(resp["err"]==false){
            texto=this.renderer.createText("La contraseña ha sido actualizada.");
            this.renderer.addClass(this.mensajeRecuperar.nativeElement, "text-success");
          }else{
            texto=this.renderer.createText(resp["msg"]);
            this.renderer.addClass(this.mensajeRecuperar.nativeElement, "text-danger");
          }
          this.renderer.appendChild(this.mensajeRecuperar.nativeElement, texto);
          setTimeout(() => {
            this.renderer.removeChild(this.mensajeRecuperar.nativeElement, texto);
            this.botonCerrar.nativeElement.click();
          }, 1500);
        })
      
      }else{
        let texto=this.renderer.createText("Las contraseñas no coinciden.");
      }
    }else{
      let texto=this.renderer.createText("Hay errores en el formulario.");
    }
  }

  guardarNuevaPassPymes(myform:NgForm){
    this.renderer.addClass(this.formulario2.nativeElement, "ng-submitted");
    if(myform.valid){
      if(this.clientePass.nextPass==this.clientePass.nextPass2){
        this.clientePass["CLcodigo"]=this.cliente["CLcodigo"];
        this.clientesPymesService.cambiarPass(this.clientePass)
        .subscribe(resp=>{
          let texto=this.renderer.createText("");
          if(resp["err"]==false){
            texto=this.renderer.createText("La contraseña ha sido actualizada.");
            this.renderer.addClass(this.mensajeRecuperar.nativeElement, "text-success");
          }else{
            texto=this.renderer.createText(resp["msg"]);
            this.renderer.addClass(this.mensajeRecuperar.nativeElement, "text-danger");
          }
          this.renderer.appendChild(this.mensajeRecuperar.nativeElement, texto);
          setTimeout(() => {
            this.renderer.removeChild(this.mensajeRecuperar.nativeElement, texto);
            this.botonCerrar.nativeElement.click();
          }, 1500);
        })
      
      }else{
        let texto=this.renderer.createText("Las contraseñas no coinciden.");
      }
    }else{
      let texto=this.renderer.createText("Hay errores en el formulario.");
    }
  }

  guardarNuevaPassInterviniente(myform:NgForm){
    this.intervinienteRecuperar["INcodigo"]=this.auth.usuarioActivo["INcodigo"];
    this.renderer.addClass(this.formulario2.nativeElement, "ng-submitted");

    if(myform.valid){
      if(this.intervinienteRecuperar['nextPass']==this.intervinienteRecuperar['nextPass2']){
        this.intervinientesService.cambiarPass(this.intervinienteRecuperar)
        .subscribe(resp=>{
          
          let texto=this.renderer.createText("");
          if(resp["err"]==false){
            texto=this.renderer.createText("La contraseña ha sido actualizada.");
            this.renderer.addClass(this.mensajeRecuperar.nativeElement, "text-success");
          }else{
            texto=this.renderer.createText(resp["msg"]);
            this.renderer.addClass(this.mensajeRecuperar.nativeElement, "text-danger");
          }
          this.renderer.appendChild(this.mensajeRecuperar.nativeElement, texto);
          setTimeout(() => {
            this.renderer.removeChild(this.mensajeRecuperar.nativeElement, texto);
            this.botonCerrar.nativeElement.click();
          },3000);
        });
      }
    }
    
    
  }

}



// WEBPACK FOOTER //
// ./src/app/components/miperfil/miperfil.component.ts